/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Hero_CtaInputs */

const en_services_hero_cta = /** @type {(inputs: Services_Hero_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore what we build`)
};

const lv_services_hero_cta = /** @type {(inputs: Services_Hero_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apskatīt, ko mēs veidojam`)
};

/**
* | output |
* | --- |
* | "Explore what we build" |
*
* @param {Services_Hero_CtaInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_hero_cta = /** @type {((inputs?: Services_Hero_CtaInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Hero_CtaInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_hero_cta(inputs)
	return en_services_hero_cta(inputs)
});